var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineUpper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 54,
    viewBox: "0 0 380 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356.533 22.5518C343.368 23.566 302.322 25.609 277.58 26.4702C252.837 27.3313 231.521 24.438 210.458 24.6987C189.395 24.9594 163.57 28.4246 143.563 28.1874C123.556 27.9503 43.9535 34.0698 22.2478 32.7365",
    stroke: "#67FC17",
    strokeOpacity: 0.7,
    strokeWidth: 42,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineUpper);
export default __webpack_public_path__ + "static/media/line-upper.f712b7ecc4095993cd212d64e292de22.svg";
export { ForwardRef as ReactComponent };